import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const mediaApi = createApi({
    reducerPath: 'mediaApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_MEDIA_SERVICE_URL,
    }),
    endpoints: (builder) => ({
        uploadMedia: builder.mutation({
            queryFn: async (arg, { getState }, _extraOptions, baseQuery) => {
                const file = arg instanceof File ? arg : arg.file;
                let userId = arg.userId;

                if (!userId) {
                    const state = getState();
                    userId = state.user?.user?.id || state.user?.user?.user_id || 0;
                }

                const formData = new FormData();
                formData.append('file', file);

                const result = await baseQuery({
                    url: `/upload?user_id=${userId}`,
                    method: 'POST',
                    body: formData,
                });

                if (result.error) {
                    return { error: result.error };
                }

                return { data: result.data };
            }
        })
    })
});

export const {
    useUploadMediaMutation
} = mediaApi;
